@if (loadPage) {
	<lbca-loading />
}

<div
	#tableComponentContainer
	[class.overflow-hidden]="addOverflowContainer"
	class="transition duration-600 ease-in-out"
>
	@if (
		dataField.showOnlyAddress && dataSelecteds.length > 0 && dataField.type === 'TABLE_SELECT_ONE'
	) {
		<section>
			@for (dataRow of dataSelecteds; track dataRow) {
				@for (data of configSecondary; track data) {
					<div>
						@for (row of data.form; track row) {
							<div>
								@for (field of row; track field) {
									<div [style.width]="field.size">
										@for (address of dataRow[field.entityKey]; track address; let index = $index) {
											<div>
												<lbca-address
													(changeData)="changeValue($event, address)"
													[require]="index === 0"
													[data]="address"
												></lbca-address>
											</div>
										}
									</div>
								}
							</div>
						}
					</div>
				}
			}
		</section>
	}

	@if (modeOperator === 'table') {
		<main
			class="table-field-chose"
			[class.component-recursive-dynamic-scape-right]="exitMotion"
			[class.component-recursive-dynamic-return]="dynamicLeave"
			[class.ttfc-error]="hasError"
		>
			<section
				class="ttfc-section-name"
				(mouseenter)="mouseenter()"
				(mouseleave)="mouseleave()"
				[class.opacity-0]="addOpacity"
			>
				<div class="ttfc-box-light">
					@if (dataField.required) {
						<div [class.ttfc-filled]="dataSelecteds.length > 0">
							<lbca-icon name="lucide:asterisk" size="small" color="primary" />
						</div>
					}
				</div>
				<div class="ttfc-label-container">
					@if (
						!dataField.showOnlyAddress &&
						dataSelecteds.length > 0 &&
						dataField.type === 'TABLE_SELECT_ONE'
					) {
						<span class="ttfc-label-name">
							{{ fieldsLabels['table-selected'] }}
						</span>
					}
					@if (dataSelecteds.length > 0 && dataField.type === 'TABLE_SELECT_LIST') {
						<span class="ttfc-label-name">
							{{ fieldsLabels['table-selecteds'] }}
						</span>
					}
					@if (
						(dataSelecteds.length === 0 && !isDisabled) || (dataSelecteds.length > 0 && isDisabled)
					) {
						<span class="ttfc-label-name">
							{{ dataField.label }}
						</span>
					}
				</div>
				<!-- *ngIf="isDisabled" -->
				<section #validationIcon class="ttfc-section-icon ml-[32px]">
					<div class="icon-box ttfc-icon-validation"></div>
				</section>
				<div class="ttfc-search-position"></div>
			</section>
			<div class="relative transition duration-600 ease-in-out" [class.opacity-0]="addOpacity">
				@if (startPlaceholder) {
					<section class="ttfc-data-row-section">
						<main class="ttfc-data-row-temp-container"></main>
					</section>
				}
				@for (dataRow of dataSelecteds; track dataRow; let i = $index) {
					<div #tableRef class="preventExpressionChangedRef"></div>
					@if (!isDisabled) {
						<section
							class="ttfc-data-row-section"
							[class.motion-topDeslocation]="topDeslocation === dataRow.id"
							[class.motion-highlight]="highlight === dataRow.id"
							[class.motion-unhighlight]="unhighlight === dataRow.id"
							[class.highlight]="highlightLine === dataRow.id"
							[class.motion-table-choose]="tableAction === 'addItem' && clickedId === dataRow.id"
							[class.motion-table-unchoose]="
								tableAction === 'removeItem' && clickedId === dataRow.id
							"
							(click)="setHighlight($event, dataRow)"
							[style.top.px]="tableRef.offsetTop"
						>
							<ng-container
								*ngTemplateOutlet="tableStruct; context: { dataRow: dataRow, checked: true }"
							></ng-container>
						</section>
					}
					@if (isDisabled) {
						<section
							class="ttfc-data-row-section"
							[class.motion-topDeslocation]="topDeslocation === dataRow.id"
							[class.motion-highlight]="highlight === dataRow.id"
							[class.motion-unhighlight]="unhighlight === dataRow.id"
							[class.highlight]="highlightLine === dataRow.id"
							[class.motion-table-choose]="tableAction === 'addItem' && clickedId === dataRow.id"
							[class.motion-table-unchoose]="
								tableAction === 'removeItem' && clickedId === dataRow.id
							"
						>
							<ng-container
								*ngTemplateOutlet="tableStruct; context: { dataRow: dataRow, checked: true }"
							></ng-container>
						</section>
					}
				}
			</div>
			@if (
				(!hideSearchBar && dataSelecteds.length <= 0) || dataField.type === 'TABLE_SELECT_LIST'
			) {
				<div>
					<ng-container></ng-container>
					@if (!isDisabled) {
						<section class="ttfc-data-search" [class.opacity-0]="addOpacity">
							<lbca-search-box
								[tagList]="tagList"
								[queryOptions]="dataField.queryOptions ? dataField.queryOptions : []"
								[placeholder]="dataField.searchPlaceholder"
								[clearDataSearch]="clearDataSearch"
								[shouldFocused]="shouldFocused"
								(clear)="clearSearchValue()"
								(clearSearchFunction)="clearSearchFunction($event)"
								(searchValue)="setSearchValue($event)"
							></lbca-search-box>
						</section>
					}
					<div
						class="overflow-x-hidden"
						[class.max-h-0]="!isSearchImage"
						[class.opacity-0]="!isSearchImage"
						[class.opacity-100]="isSearchImage"
					>
						@for (dataRow of dataTable; track dataRow; let i = $index) {
							<section class="ttfc-data-row-section" (click)="selectValue(dataRow, $event)">
								<ng-container
									*ngTemplateOutlet="tableStruct; context: { dataRow: dataRow, checked: false }"
								></ng-container>
							</section>
						}
					</div>
					@if (dataSelecteds.length <= 0 && isDisabled) {
						<lbca-body-feedback type="table-list">
							<ng-container tableMessagePrimary>
								Nenhuma informação para
								<br />
								visualizar
							</ng-container>
						</lbca-body-feedback>
					}
					@if (!isSearchImage && !isLoaded && !isDisabled) {
						<div class="min-h-[180px]">
							<lbca-body-feedback place="module" feedbackIcon="searching" type="row">
								<ng-container rowMessagePrimary>{{ fieldsLabels['searching'] }}</ng-container>
							</lbca-body-feedback>
						</div>
					}
					@if (dataTable.length === 0 && !isSearchImage && isLoaded && !isDisabled) {
						<div class="min-h-[180px]">
							@if (!isSearchImage) {
								<lbca-body-feedback place="module" type="panel"></lbca-body-feedback>
							}
						</div>
					}
					@if (dataTable.length === 0 && firstSearchComplete && isSearchImage && isLoaded) {
						<div class="min-h-[180px]" [class.opacity-0]="addOpacity">
							<lbca-body-feedback place="module" feedbackIcon="notfound" type="row">
								<ng-container rowMessagePrimary>{{ fieldsLabels['table-not-found'] }}</ng-container>
								<ng-container rowMessageSecondary>
									{{ fieldsLabels['table-try-new-search'] }}
								</ng-container>
							</lbca-body-feedback>
						</div>
					}
					@if (!isDisabled) {
						<div class="w-full h-[40px] justify-center flex relative">
							@if (getHasCapability()) {
								<div
									(click)="getTemplateForNew()"
									#buttonRegister
									class="absolute flex cursor-pointer show left-[0px] top-[16px] transition duration-600 ease-in-out"
								>
									<button class="btn-type-3 btn-primary ml-[7px]">
										<lbca-icon name="lucide:plus" />
									</button>
									<span
										class="h-[32px] flex justify-center ml-[12px] mt-[4px] text-sm text-gray-700"
									>
										{{ fieldsLabels['new-entity'] }}
									</span>
								</div>
							}
							@if (dataTable.length > 0) {
								<lbca-pagination
									[class.opacity-0]="addOpacity"
									[actualPage]="1"
									(selectedPage)="selectedPage($event)"
									(orientation)="orientation($event)"
									[maxPages]="totalPagesValue"
								></lbca-pagination>
							}
						</div>
					}
				</div>
			}
			<ng-template #tableStruct let-dataRow="dataRow" let-checked="checked">
				<main class="ttf-main-section-template">
					<section class="ttfc-data-row-div">
						@if (checked) {
							<lbca-icon name="lucide:check" color="primary" />
						}
						<div class="ttfc-data-row-section-inside">
							@for (dataColumn of configPrimary; track dataColumn) {
								<div
									class="ttfc-box-field"
									[ngClass]="'ttfc-field-size-' + dataColumn.size"
									[class.checked]="checked"
								>
									@if (dataRow[dataColumn.entityKey]) {
										<div>
											@if (dataColumn.type === 'HIDDEN') {
												<lbca-input-hidden
													[label]="dataColumn.label"
													[defaultValue]="dataRow[dataColumn.entityKey]"
												></lbca-input-hidden>
											}
											@if (dataColumn.type === 'TEXT') {
												<lbca-input-text
													[label]="dataColumn.label"
													[labeled]="false"
													[error]="error ? error[dataColumn.entityKey] : null"
													[disabled]="dataColumn.disable"
													[require]="dataColumn.required"
													[maskInput]="dataColumn.mask"
													[value]="dataRow[dataColumn.entityKey]"
												></lbca-input-text>
											}
											@if (dataColumn.type === 'CALENDAR') {
												<lbca-date-picker
													[labeled]="false"
													[editable]="dataColumn.editable && !disabled"
													[label]="dataColumn.label"
													[require]="dataColumn.required"
													[error]="error ? error[dataColumn.entityKey] : null"
													[value]="dataRow[dataColumn.name]"
													[rules]="dataColumn.rules"
													[disabledDateRules]="dataColumn.disabledDateRules"
												></lbca-date-picker>
											}
											@if (dataColumn.type === 'DATE_TIME') {
												<lbca-date-time-picker
													[labelDate]="dataColumn.labelDate"
													[labelTime]="dataColumn.labelTime"
													[require]="dataColumn.required"
													[error]="error ? error[dataColumn.entityKey] : null"
													[editable]="dataColumn.editable && !disabled"
													[value]="dataRow[dataColumn.name]"
													[rules]="dataColumn.rules"
													[disabledDateRules]="dataColumn.disabledDateRules"
													[labeled]="false"
												></lbca-date-time-picker>
											}
											@if (dataColumn.type === 'TIME') {
												<lbca-timepicker
													[label]="dataColumn.label"
													[labeled]="false"
													[error]="error ? error[dataColumn.entityKey] : null"
													[disabled]="dataColumn.disable"
													[require]="dataColumn.required"
													[value]="dataRow[dataColumn.name]"
												></lbca-timepicker>
											}
											@if (dataColumn.auxEntity) {
												<lbca-entity-fields
													[forceType]="'SELECT_ONE'"
													[label]="dataColumn.label"
													[cardData]="cardInfo"
													[labeled]="false"
													[error]="error ? error[dataColumn.entityKey] : null"
													[disabled]="dataColumn.disable"
													[field]="dataColumn"
													[require]="dataColumn.required"
													[value]="dataRow[dataColumn.entityKey]"
												></lbca-entity-fields>
											}
											@if (dataColumn.type === 'OAB') {
												<lbca-oab
													[label]="dataColumn.label"
													[cardData]="cardInfo"
													[labeled]="false"
													[error]="error ? error[dataColumn.entityKey] : null"
													[disabled]="dataColumn.disable"
													[require]="dataColumn.required"
													[value]="dataRow[dataColumn.entityKey]"
												></lbca-oab>
											}
										</div>
									}
								</div>
							}
						</div>
						<div class="w-12 flex justify-end pr-[15px]">
							<div
								class="transition duration-400 ease-in-out"
								[class.opacity-0]="!configSecondary || configSecondary.length === 0"
								[class.rotate-180]="dataRow.opened"
								(click)="troggleOption($event, dataRow)"
							>
								<lbca-icon name="lucide:chevron-down" color="primary" />
							</div>
							@if ((checked && checkedOptions.length > 0) || (!checked && options.length > 0)) {
								<lbca-options
									[options]="checked ? checkedOptions : options"
									[close]="closeOption"
									(closeNestedOpt)="closeAll()"
									(selectOption)="selectOption($event, dataRow)"
								></lbca-options>
							}
							@if (checked && !isDisabled) {
								<div (click)="removeSelected($event, dataRow)">
									<lbca-icon name="ic:baseline-close" color="primary" />
								</div>
							}
						</div>
					</section>
					@if (dataRow.opened) {
						<section class="ttfc-details">
							@for (dataDetSection of configSecondary; track dataDetSection) {
								<div class="ttfc-section-form">
									<div class="ttfc-section-det-label">{{ dataDetSection.label }}</div>
									<div class="ttfc-section-det-form" style="width: calc(100% - 92px)">
										@for (row of dataDetSection.form; track row) {
											<div class="ttfc-section-det-row" (click)="preventCloseDetails($event)">
												@for (field of row; track field) {
													<div [style.width]="field.size" class="ttfc-section-det-field">
														@if (field.type === 'TEXT') {
															<lbca-input-text
																[label]="field.label"
																[labeled]="false"
																[error]="error ? error[field.entityKey] : null"
																[require]="field.required"
																[maskInput]="field.mask"
																[value]="dataRow[field.entityKey]"
															></lbca-input-text>
														}
														@if (field.type === 'GRIDBOX') {
															<lbca-gridbox
																[field]="field"
																[labeled]="false"
																[configuration]="field.configuration"
																[template]="field.template"
																[label]="field.label"
																[error]="error ? error[field.entityKey] : null"
																[require]="field.required"
																[dynamicFormService]="dynamicFormService"
																[gridFormModuleInstance]="gridFormModuleInstance"
																[cardData]="cardInfo"
																[value]="dataRow[field.entityKey]"
															></lbca-gridbox>
														}
														@if (field.type === 'GRIDBOX_UNIQUE') {
															<lbca-gridbox-unique
																[field]="field"
																[labeled]="false"
																[configuration]="field.configuration"
																[cardData]="cardInfo"
																[label]="field.label"
																[error]="error ? error[field.entityKey] : null"
																[require]="field.required"
																[value]="dataRow[field.entityKey]"
															></lbca-gridbox-unique>
														}
														@if (field.type === 'LIST_ADDRESS') {
															<lbca-address-list
																[require]="field.required"
																[label]="field.label"
																[labeled]="false"
																[value]="dataRow[field.entityKey]"
															></lbca-address-list>
														}
														@if (field.type === 'OAB') {
															<lbca-oab
																[label]="field.label"
																[cardData]="cardInfo"
																[labeled]="false"
																[error]="error ? error[field.entityKey] : null"
																[disabled]="field.disable"
																[require]="field.required"
																[value]="dataRow[field.entityKey]"
															></lbca-oab>
														}
													</div>
												}
											</div>
										}
									</div>
								</div>
							}
						</section>
					}
				</main>
			</ng-template>
			<ng-template #templateFeedbackAdded>
				<div class="text-base text-font flex items-center justify-center show">
					{{ feedbackAdded }}
					<lbca-icon
						name="emoji--positive"
						class="emojis-positive ml-[16px] w-6 h-[24px] flex justify-center items-center pt-[8px] pb-[8px]"
					></lbca-icon>
				</div>
			</ng-template>
			<ng-template #templateFeedbackRemoved>
				<div class="text-base text-font flex items-center justify-center show">
					{{ feedbackRemoved }}
					<lbca-icon
						name="emoji--positive"
						class="emojis-positive ml-[16px] w-6 h-[24px] flex justify-center items-center pt-[8px] pb-[8px]"
					></lbca-icon>
				</div>
			</ng-template>
			<ng-template #templateFeedbackRegistered>
				<div class="text-base text-font flex items-center justify-center show">
					{{ feedbackRegistered }}
					<lbca-icon
						name="emoji--positive"
						class="emojis-positive ml-[16px] w-6 h-[24px] flex justify-center items-center pt-[8px] pb-[8px]"
					></lbca-icon>
				</div>
			</ng-template>
		</main>
	}

	@if (modeOperator === 'form') {
		<main
			[class.component-recursive-dynamic]="dynamicEnter"
			[class.component-recursive-dynamic-scape-left]="dynamicLeave"
		>
			<div class="w-full flex justify-center items-center relative mt-[8px]">
				<span
					class="svg-icon-arrow icon-box bg-primary ml-[7px] mr-[10px] cursor-pointer"
					(click)="setTableState('table')"
				></span>
				<div class="text-primary text-2xl text">{{ newEntityTemplate['label'] }}</div>
				<div class="h-[24px] ml-[72px] grow flex mt-[12px] mr-[7px]">
					<div class="h-[2px] grow mt-[12px] mr-[12px]"></div>
					<div class="flex flex-row items-center">
						<button class="btn-secondary btn-type-3" (click)="openChildFormState(true)">
							<span class="bg-1 svg-icon-angle"></span>
						</button>
						<button class="btn-secondary btn-type-3 ml-[4px]" (click)="openChildFormState(false)">
							<span class="bg-1 svg-icon-angle rotate-180"></span>
						</button>
					</div>
				</div>
			</div>
			<div class="h-[48px] w-full"></div>
				<lbca-dynamic-form
					(formValidFunctionCallback)="formValidFunctionCallback($event)"
					[externalData]="{}"
					[cardData]="cardInfo"
					[initialized]="true"
					[forceStateOpened]="formForceStateOpen"
					(errorApi)="errorApi()"
					(subformData)="setChildrenFormData($event)"
					[type]="'form-secondary'"
					[errorPostData]="errorPostData"
					[modulesConfig]="newEntityTemplate['subforms']"
					(controlCloud)="getControlCloud()"
				></lbca-dynamic-form>
			<div class="flex mt-[62px] mb-[7px]">
				<button
					type="button"
					class="btn-secondary btn-type-2 ml-[4px]"
					(click)="setTableState('table')"
				>
					Cancelar
				</button>
				<button
					type="button"
					class="btn-primary btn-type-2 ml-[25px] load-action"
					[class.btn-motion-bg-1]="submitButtonNewEntity"
					[disabled]="submitButtonNewEntity"
					(click)="saveNewEntity()"
				>
					@if (!submitButtonNewEntity) {
						Salvar
					}
					@if (submitButtonNewEntity) {
						<img class="forgot-loading" src="./assets/icons/loading-points.svg" />
					}
				</button>
			</div>
		</main>
	}
</div>
